// extracted by mini-css-extract-plugin
export default {"root":"CHX9Mu","paper":"Gp8dhz"};